import { isStaging } from '@/helpers/environment'

export const defaultPrices = isStaging
  ? [
    { quantity: 1, priceId: 'pri_01j6csxga3n97gb66n5ppcc99q' },
    { quantity: 1, priceId: 'pri_01j6csvtcn8dg91r5abjcwbr61' },
  ]
  : [
    { quantity: 1, priceId: 'pri_01jdptfzpj2f9e1pck4ww3a2w8' },
    { quantity: 1, priceId: 'pri_01jdptj38adev76780hgbqevsr' },
  ]

export const ceoPrices = isStaging
  ? [
    { quantity: 1, priceId: 'pri_01j6csxga3n97gb66n5ppcc99q' },
    { quantity: 1, priceId: 'pri_01j6csvtcn8dg91r5abjcwbr61' },
  ]
  : [
    { quantity: 1, priceId: 'pri_01jdptfzpj2f9e1pck4ww3a2w8' },
    { quantity: 1, priceId: 'pri_01jdptj38adev76780hgbqevsr' },
  ]
